<template>
  <b-modal
    size="md"
    hide-footer
    v-model="show"
    :title="`Alterar Senha de Usuário`"
    @hidden="cancelar"
  >
    <b-card>
      <b-row>
        <b-col cols="12">
          <div>
            <span class="font-weight-bold">Configuração:</span> {{ configuracao.tituloPropriedade }}
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-form @submit.prevent="salvar">
      <b-form-group>
        <lg-form-input
          v-model="form.senhaAtual"
          label="Senha Atual:"
          type="password"
          required
          placeholder="Digite sua senha atual"
        />
      </b-form-group>
      <b-form-group>
        <lg-form-input
          v-model="form.novaSenha"
          label="Nova Senha:"
          type="password"
          required
          placeholder="Digite a nova senha"
        />
      </b-form-group>
      <b-form-group>
        <lg-form-input
          v-model="form.confirmarNovaSenha"
          label="Confirmar Nova Senha:"
          type="password"
          required
          placeholder="Confirme a nova senha"
        />
      </b-form-group>
      <b-form-row class="d-flex justify-content-center">
        <b-button type="submit" size="sm" pill variant="success">
          <b-icon icon="check-circle" />
        </b-button>
        <b-button size="sm" pill variant="danger" @click="cancelar" class="ml-2">
          <b-icon icon="x-circle" />
        </b-button>
      </b-form-row>
    </b-form>
  </b-modal>
</template>

<script>
import lgFormInput from "@/core/components/Form/LgFormInput.vue";
import Swal from "sweetalert2";

export default {
  name: "AlterarSenhaUsuarioModal",
  components: {
    lgFormInput,
  },
  props: {
    configuracao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: true,
      form: {
        senhaAtual: "",
        novaSenha: "",
        confirmarNovaSenha: "",
      },
    };
  },
  methods: {
    salvar() {
      if (this.form.novaSenha !== this.form.confirmarNovaSenha) {
        this.$bvToast.toast("As senhas não coincidem", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
        return;
      }

      Swal.fire({
        title: "Sucesso",
        text: "Senha alterada com sucesso!",
        icon: "success",
        confirmButtonText: "OK",
      });

      this.cancelar();
    },
    cancelar() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.font-weight-bold {
  font-weight: bold;
}
</style>
